var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCissor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11751_1561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.22268 11.3434L14.8104 15.8959C15.4679 16.2762 16.0874 16.7187 16.6603 17.2174L22.4728 23.0299C22.5422 23.0994 22.6246 23.1544 22.7153 23.192C22.806 23.2296 22.9032 23.2489 23.0014 23.2489C23.0995 23.2489 23.1967 23.2296 23.2874 23.192C23.3781 23.1544 23.4605 23.0994 23.5299 23.0299C23.5994 22.9605 23.6544 22.8781 23.692 22.7874C23.7296 22.6967 23.7489 22.5995 23.7489 22.5014C23.7489 22.4032 23.7296 22.306 23.692 22.2153C23.6544 22.1246 23.5994 22.0422 23.5299 21.9728L17.7174 16.1603C17.1995 15.6029 16.7553 14.9811 16.3959 14.3104L11.8434 6.72268M11.3102 6.71143L7.21143 10.8102",
    stroke: "#8F99D3",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7534 5.85378C14.921 4.68617 14.921 2.79308 13.7534 1.62546C12.5858 0.457844 10.6927 0.457844 9.52505 1.62546C8.35743 2.79308 8.35743 4.68617 9.52505 5.85378C10.6927 7.0214 12.5858 7.0214 13.7534 5.85378Z",
    stroke: "#8F99D3",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3542 13.2534C7.52182 12.0858 7.52182 10.1927 6.3542 9.02512C5.18658 7.8575 3.2935 7.8575 2.12588 9.02512C0.958261 10.1927 0.958261 12.0858 2.12588 13.2534C3.2935 14.4211 5.18658 14.4211 6.3542 13.2534Z",
    stroke: "#8F99D3",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11751_1561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#8F99D3",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCissor);
export default __webpack_public_path__ + "static/media/cissor.9635cd83.svg";
export { ForwardRef as ReactComponent };